import React, { PropsWithChildren } from 'react';
import { DefaultValues, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useFormCepAutocomplete } from '@area-restrita/client';

import { Form } from '@/components/ui/form';

import AddressFormStepView from './view';
import { ICompanyAddressFormSchema, companyAddressSchema } from './schema';

interface IProps extends PropsWithChildren {
  defaultValues?: DefaultValues<ICompanyAddressFormSchema>;
  onSubmit: SubmitHandler<ICompanyAddressFormSchema>;
}

const AddressFormStep: React.FC<IProps> = ({
  defaultValues,
  onSubmit,
  children,
}) => {
  const form = useForm<ICompanyAddressFormSchema>({
    defaultValues,
    resolver: zodResolver(companyAddressSchema),
  });

  useFormCepAutocomplete(form);

  return (
    <Form {...form}>
      <AddressFormStepView
        control={form.control}
        isLoading={form.formState.isSubmitting}
        onSubmit={form.handleSubmit(onSubmit)}
      >
        {children}
      </AddressFormStepView>
    </Form>
  );
};

export default AddressFormStep;
